const isAssignmentSegment = (segment: string) => segment.toLowerCase() === 'assignment';

/**
 * The assignment id carried by an `/assignment/...` URL, or null anywhere else.
 * Empty segments are dropped so a trailing slash can never yield `''`, which the
 * draft-guess endpoints reject and which `shouldNotSaveDraft` treats as present.
 * The keyword match is case-insensitive because the router is.
 */
export const getAssignmentIdFromPath = (
  pathname: string = global.location.pathname
): string | null => {
  const segments = pathname.split('/').filter(Boolean);
  if (!segments.some(isAssignmentSegment)) {
    return null;
  }
  const last = segments[segments.length - 1];
  return isAssignmentSegment(last) ? null : last;
};
